import type { Chat } from '@shady-pines/db';
import type { Uuid } from '@shady-pines/types';
import { useSubscription } from '../realtime/use-supabase-subscription';
import { useMessages } from './use-messages';

export const useChatMessages = ({ chatId }: { chatId: Uuid<Chat> }) => {
  const { messages, sendMessage, ...rest } = useMessages({ chatId });

  useSubscription(
    'INSERT',
    'messaging_messages',
    (payload) => {
      const newMessage = payload.new;
      if ('chat_id' in newMessage && newMessage.chat_id === chatId) {
        console.log('TODO');
      }
    },
    chatId,
  );

  return {
    messages,
    sendMessage,
    ...rest,
  };
};
